import { render, staticRenderFns } from "./importFile.vue?vue&type=template&id=2dd72cc0&scoped=true"
import script from "./importFile.vue?vue&type=script&setup=true&lang=js"
export * from "./importFile.vue?vue&type=script&setup=true&lang=js"
import style0 from "./importFile.vue?vue&type=style&index=0&id=2dd72cc0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd72cc0",
  null
  
)

export default component.exports